import React from 'react'

import LoadPanel from 'devextreme-react/load-panel'

export const FullPageSpinner = () => {
    return (
        <LoadPanel
            position={{of: "#root"}}
            visible={true}
            shadingColor='rgba(0, 0, 0, 0.4)'
            shading={true}
            showIndicator={true}
            showPane={true}
        />
    )
}
